// extracted by css-extract-rspack-plugin
export default {"avatar":"Users-module__avatar__Bqxpc","sponsorButton":"Users-module__sponsorButton__QHTer"};